<template>
  <div>
    <markdown-document-modal />
    <sharing-modal />
    <app-share-modal />
    <active-apps-selection-modal />
  </div>
</template>

<script>
import MarkdownDocumentModal from './MarkdownDocumentModal.vue';
import SharingModal from './modals/SharePageModal.vue';
import AppShareModal from './modals/AppShareModal.vue';
import ActiveAppsSelectionModal from './modals/ActiveAppsSelectionModal.vue';

export default {
  components: {
    MarkdownDocumentModal,
    SharingModal,
    AppShareModal,
    ActiveAppsSelectionModal,
  },
};
</script>
